import { Badge, Box, Drawer, Fab } from "@mui/material"
import { Chat } from "@mui/icons-material";

import { Chats } from "../../chat/Chats";

export const ChatDrawer = ({ isOpen, setIsOpen, campanha, campainNotifications }) => {
  return (
    <>
        <Drawer
            anchor="right"
            open={isOpen}
            onClose={() => setIsOpen(false)}
            PaperProps={{
                sx: {
                    width: { xs: "80%", sm: "400px" },
                    backgroundColor: "var(--white-color)",
                    transition: "width 0.3s ease-in-out",
                },
            }}
            BackdropProps={{
                sx: {
                    backgroundColor: "rgba(0,0,0,0.3)",
                    backdropFilter: "blur(4px)",
                },
            }}
        >
            <Box sx={{ height: "100%" }}>
                <Chats
                    hasHeader
                    headerTitle="Chat da Campanha"
                    title="Mensagens"
                    item={campanha}
                    contexto="ADMIN_CREATOR_CAMPANHA"
                />
            </Box>
        </Drawer>
        <ChatButton
            onClick={() => setIsOpen(true)}
            campainNotifications={campainNotifications}
        />
    </>
  );
};

const ChatButton = ({ onClick, campainNotifications }) => (
    <Fab
        color="info"
        aria-label="chat"
        sx={{
            position: "fixed",
            bottom: 60,
            right: 30,
            backgroundColor: "var(--primary-color)",
            "&:hover": {
                backgroundColor: "var(--primary-dark-color)",
            },
        }}
        onClick={onClick}
    >
        <Badge badgeContent={campainNotifications} color="secondary">
            <Chat />
        </Badge>
    </Fab>
);
